import {Component, EventEmitter, Input, Output} from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import 'firebase/firestore';
import {AsyncPipe, NgClass, NgIf} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {getAuth} from "firebase/auth";
import {addDoc, collection, Firestore} from "@angular/fire/firestore";
import {Router, RouterLink} from "@angular/router";
import {TeacherService} from "../services/teacher.service";
import {Grant} from "../interfaces/grant";
import {Teacher} from "../interfaces/teacher";
import firebase from 'firebase/compat/app';

@Component({
  selector: 'app-grants-form',
  templateUrl: './grants-form.component.html',
  standalone: true,
  imports: [
    AsyncPipe,
    FormsModule,
    NgIf,
    NgClass,
    RouterLink
  ],
  styleUrl: './grants-form.component.css'
})
export class GrantsFormComponent {
  @Input() isEditMode: boolean = false;
  @Input() grantId?: string;
  now = new Date();
  teacher: Teacher | null = null;

  formData: Grant = {
    status: '',
    name: '',
    applicationOpenDate: '',
    applicationCloseDate: '',
    webLink: '',
    description: '',
    contactPhone: '',
    commentary: '',
    amount: 0,
    createdBy: '',
    creationDate: '',
    updatedBy: '',
    updatedDate: '',
    isDeleted: false,
    contactName: ''
  };
  @Output() formSubmitted = new EventEmitter<Grant>();

  constructor(public afAuth: AngularFireAuth, private firestore: Firestore, private router: Router, private teacherService: TeacherService) {}

  protected readonly onclick = onclick;
  protected readonly String = String;

  async ngOnInit(){
    this.teacher = await this.teacherService.getTeacher();

  }

  initializeForm(grant: Grant) {
    const currentTime = new Date().toISOString();
    this.formData = {
      ...grant,
      creationDate: currentTime,
      updatedDate: currentTime,
    };
  }

  allowNumbersOnly(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
    if (allowedKeys.includes(event.key)) return;
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }


  async submitForm() {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      alert('You must be logged in to submit this form.');
      return;
    }

    try {
      if (
        this.formData.applicationOpenDate &&
        this.formData.applicationCloseDate &&
        new Date(this.formData.applicationOpenDate) > new Date(this.formData.applicationCloseDate)
      ) {
        alert('The opening date cannot be after the closing date.');
        return;
      }

      const formCollection = collection(this.firestore, 'grant');
      const currentTime = new Date().toISOString();
      const teacherName = `${this.teacher?.fName ?? ''} ${this.teacher?.lName ?? ''}`.trim();

      const dataToSave: any = {
        ...this.formData
      };

      if (this.isEditMode && this.grantId) {
        const docRef = firebase.firestore().collection('grant').doc(this.grantId);
        const existingDoc = await docRef.get();

        if (existingDoc.exists) {
          const existingData = existingDoc.data();
          dataToSave['createdBy'] = existingData?.['createdBy'];
          dataToSave['creationDate'] = existingData?.['creationDate'];
        }

        dataToSave['updatedBy'] = teacherName;
        dataToSave['updatedDate'] = currentTime;

        await docRef.update(dataToSave);

        alert('Grant updated successfully!');
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate([`/grants/${this.grantId}`]);
        });

      } else {
        dataToSave['createdBy'] = teacherName;
        dataToSave['creationDate'] = currentTime;

        dataToSave['updatedBy'] = teacherName;
        dataToSave['updatedDate'] = currentTime;

        const docRef = await addDoc(formCollection, dataToSave);

        alert('Form submitted successfully!');
        this.router.navigate([`/grants/${docRef.id}`]);
      }

    } catch (error: any) {
      console.error(error);
      alert(`Error submitting form: ${error.message}`);
    }
  }
}
